<template>
  <LegalPage>
    <AppContainer>
      <component :is="componentMap[language]" />
    </AppContainer>
  </LegalPage>
</template>

<script setup lang="ts">
import { LazyTermsEn, LazyTermsSv, LazyTermsHe, LazyTermsRu } from '#components';
import { localeToLanguage } from '~/helpers/format';
import type { Language } from "~/types";

const { locale, tt } = useLocalization();
const language = localeToLanguage(locale.value);
usePageHead({
  title: tt('terms_page.title'),
  description: tt('terms_page.meta_desc'),
  image: {
    src: '/images/desk.webp',
    width: 496,
    height: 750,
    alt: tt('contact_page.desk')
  },
  alternateBranches: 'all',
});
const componentMap: Record<Language, Component> = {
  he: LazyTermsHe,
  en: LazyTermsEn,
  sv: LazyTermsSv,
  ru: LazyTermsRu
};
</script>